import { booleanAttribute, Component, EventEmitter, inject, Input, OnInit, Output } from "@angular/core";
import { PeriodIdentification, YearIdentification } from "@app/core/domain/plan-details";
import { CourseDetail, CoursePeriod } from "@core/domain/course-detail";
import { AuthService } from "@core/services/auth.service";
import { TranslateModule } from "@ngx-translate/core";
import { SelectedPeriod } from "@shared/types/course-data";
import {
  AvailableSlot,
  PeriodSelectionGridComponent,
} from "../../period-selection-grid/period-selection-grid.component";

@Component({
  selector: "pa-plan-element",
  templateUrl: "./plan-element.component.html",
  styleUrls: ["./plan-element.component.scss"],
  imports: [PeriodSelectionGridComponent, TranslateModule],
})
export class PlanElementComponent implements OnInit {
  @Input() label?: string;
  @Input() courseDetail!: CourseDetail;
  @Input({ transform: booleanAttribute }) isScheduleSelectable = false;
  @Output() selectedPeriod = new EventEmitter<SelectedPeriod>();

  textCancel = "label.cancel";
  private readonly authService = inject(AuthService);
  timeSlotLabel = "";

  availableSlots: AvailableSlot[] = [];
  periods: CoursePeriod[] = [];

  ngOnInit(): void {
    document.documentElement.style.setProperty(
      "--element-period-columns",
      (this.courseDetail?.courseYears?.[0]?.periods?.length
        ? this.courseDetail.courseYears[0].periods.length + 1
        : 1
      ).toString(),
    );

    this.periods = this.courseDetail?.courseYears?.[0]?.periods || [];
    this.availableSlots =
      this.courseDetail?.courseYears?.flatMap((courseYear) =>
        courseYear.periods
          .filter((period) => period.offered)
          .map((period) => ({
            yearNr: courseYear.yearNr,
            periodNr: period.periodNr,
            timeslots: period.timeslots,
          })),
      ) || [];

    if (this.authService.isRoleEmployeeViewsStudentPlan()) {
      this.isScheduleSelectable = false;
    }
  }

  clickOnPeriod(event: { year: YearIdentification; period: PeriodIdentification }): void {
    if (this.isScheduleSelectable) {
      this.selectPeriod(event.year, event.period);
    }
  }

  private selectPeriod(year: YearIdentification, period: PeriodIdentification): void {
    if (this.isScheduleSelectable) {
      // find the CourseYear and CoursePeriod corresponding to the selected year and period
      const selectedCourseYear = this.courseDetail.courseYears.find((courseYear) => courseYear.yearNr === year.yearNr);
      const selectedCoursePeriod = selectedCourseYear?.periods.find(
        (coursePeriod) => coursePeriod.periodNr === period.periodNr,
      );
      this.selectedPeriod.emit({ year: selectedCourseYear!, period: selectedCoursePeriod! });
    }
  }
}
